import http, { BASE_URL_3 } from '../../http';
import { getRBPStringId } from '../../../page/main/main-page-states';

/**
 * 员工等级（权限模板）——与终端 RBP `staff-manager` 中 `employee_class` 接口语义一致，
 * 路径按云 Shell 惯例挂载当前餐厅 `string_id`。
 */
const employeeClassApi = {
    async get_employee_permission_setting(rbpStringId?: string): Promise<unknown> {
        const sid = (rbpStringId && rbpStringId.trim()) || getRBPStringId();
        return await http.get(`${BASE_URL_3}/employee_class/${sid}`);
    },

    async post_employee_permission_setting(
        params: { employee_class_name: string },
        rbpStringId?: string,
    ): Promise<unknown> {
        const sid = (rbpStringId && rbpStringId.trim()) || getRBPStringId();
        return await http.post(`${BASE_URL_3}/employee_class/${sid}`, params);
    },

    async patch_employee_permission_setting(
        id: number,
        data: Record<string, unknown>,
        rbpStringId?: string,
    ): Promise<unknown> {
        const sid = (rbpStringId && rbpStringId.trim()) || getRBPStringId();
        return await http.patch(`${BASE_URL_3}/employee_class/${id}/${sid}`, data);
    },

    async delete_employee_permission_setting(id: number, rbpStringId?: string): Promise<unknown> {
        const sid = (rbpStringId && rbpStringId.trim()) || getRBPStringId();
        return await http.delete(`${BASE_URL_3}/employee_class/${id}/${sid}`);
    },
};

export default employeeClassApi;
